/**
 * A wrapper for local storage with error handling
 * Wraps local storage gets, sets and removes and saves and parses objects instead of strings
 * Allows use of serialized objects
 */
namespace appn.localStorage {
    /**
     * Change the date here to ensure a fresh local storage on next load
     */
    const _clearLsKey: string = 'freshLs-Web30Mar2022';

    /**
     * Gets an object from localstorage
     * @param key
     */
    export function getItem(key: string): any {
        let item = null;

        try {
            const lsValue: any = window.localStorage.getItem(key);
            item = lsValue ? JSON.parse(lsValue) : null;
        } catch (e: any) {
            if (e && e.message)
                console.log(e.message);
        }

        return item;
    }

    /**
     * Creates or Updates an object in localstorage
     * @param key
     * @param value
     */
    export function setItem(key: string, value: any) {
        let isSet = true;

        try {
            window.localStorage.setItem(key, JSON.stringify(value));
        } catch (e: any) {
            isSet = false;
            if (e && e.message)
                appn.log.error(e.message, true);
        }

        return isSet;
    }

    /**
     * Removes an object from localstorage
     * @param key
     */
    export function removeItem(key: string) {
        try {
            window.localStorage.removeItem(key);
        } catch (e: any) {
            if (e && e.message)
                console.log(e.message);
        }
    }

    /**
     * Clears EVERYTHING out of local storage
     */
    export function clearAll() {
        try {
            window.localStorage.clear();
        } catch (e: any) {
            if (e && e.message)
                console.log(e.message);
        }
    }

    /**
     * Refreshes Local Storage if freshLs doesn't exist
     */
    export function autoClearLs() {
        const hasLsBeenAutoCleared = appn.localStorage.getItem(_clearLsKey);
        if (hasLsBeenAutoCleared)
            return;

        // Clear all local storage
        clearAllAndSetFreshLs();
    }

    /**
     * Clear All and set flag.
     */
    export function clearAllAndSetFreshLs() {
        appn.localStorage.clearAll();
        appn.localStorage.setItem(_clearLsKey, true);
    }
}
